import { createSlice } from '@reduxjs/toolkit';

import IInfo from '../types/common/IInfo';
import InfoService from '../services/common/InfoService';
import { LOGOUT } from '../constants/actions/auth.constants';
import defaultLocales from '../config/defaultLocales.json';
import InfoSelectors from '../selectors/InfoSelectors';
import type { AppState } from '../reducers/root.reducer';
import { createNotifiedThunk } from '../reducers/createAppAsyncThunk';

const NAME = 'Info';

const getInfo = createNotifiedThunk(
    `${NAME}/getInfo`,
    InfoService.getInfo,
    { error: 'Nepodařilo se načíst info' },
    {
        condition: (_arg, { getState }) => {
            const info = InfoSelectors.getInfo(getState() as AppState);
            return !info.loading;
        },
    },
);

type State = {
    data: IInfo | undefined;
    loading: boolean;
    error: boolean;
};

const initialState: State = {
    data: undefined,
    loading: false,
    error: false,
};

const slice = createSlice({
    name: NAME,
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(getInfo.pending, (state) => {
            if (state.loading === false) {
                state.loading = true;
                state.error = false;
            }
        });
        builder.addCase(getInfo.fulfilled, (state, action) => {
            if (state.loading === true) {
                state.loading = false;
                state.data = action.payload?.data;
            }
        });
        builder.addCase(getInfo.rejected, (state) => {
            if (state.loading === true) {
                state.loading = false;
                state.error = true;
                state.data = {
                    languages: defaultLocales as string[],
                    translationVersion: 'v0.0.1',
                    logo: '',
                    customization: null,
                    companyId: null,
                    companyName: null,
                };
            }
        });

        builder.addCase(LOGOUT, () => initialState);
    },
});

const InfoActions = {
    getInfo,
};

export default InfoActions;
export const InfoReducer = slice.reducer;
